/**
import all locale translation from different module
and export from this file.
 **/
import homepage from '@/Homepage/langs/zh_cn'
import auth from '@/Auth/langs/zh_cn'
import error from '@/ErrorPage/langs/zh_cn'
import fitComponents from '@/components/langs/zh_cn'
import adm from '@/Adm/langs/zh_cn'
import crm from '@/Crm/langs/zh_cn'
import osm from '@/Osm/langs/zh_cn'
import my from '@/My/langs/zh_cn'
import dw from '@/Dw/langs/zh_cn'
import validation from '@/Validation/langs/zh_cn'
import quick from '@/Quick/langs/zh_cn'

export default {
  hm: '主页',
  general: {
    batchSelect: '多项选择',
    selectable: '可选择',
    submit: '提交',
    add: '添加',
    remove: '删除',
    logout: '登出',
    language: '系统语言',
    updateSuccess: '更新成功。',
    updateError: '更新失败，请稍后再试',
    deleteSuccess: '删除成功。',
    selectDate: '请选择日期',
    autoSearchText: '抱歉，无匹配选项',
    ok: '是',
    cancel: '取消',
    confirm: '确认',
    notification: '提示',
    message: '讯息',
    yes: '是',
    no: '否',
    save: '储存',
    create: '创建',
    edit: '修改',
    pagination: {
      perPage: '每页项目',
      items: '页数 {page} / 总共 {total} 项目'
    },
    action: '操作',

    fromDate: '开始日期',
    toDate: '结束日期',
    clearFilter: '清除选项',

    search: '检索关键字',
    total: '总共',
    records: '纪录',
    all: '所有',
    more: '更多',
    date: '日期',
    perPage: '每页',

    M: '男',
    F: '女',

    //CURD Text
    CURD: {
      create: '创建',
      edit: '修改',
      actions: '操作',
      update: '更新',
      retrieve: '查看',
      delete: '删除',
      approve: '批准',
      reject: '拒绝',
      next: '下一步',
      complete: '完成',
      prev: '上一步',
      deleteConfirmMessage: '确认删除这些纪录吗？',
      save: '储存'
    },
    workflow: {
      next: '下一步',
      previous: '上一步',
      finish: '完成'
    },
    gender: '性别',
    dateOfBirth: '出生日期',
    identityCardNo: '身分证号码',
    companyAddress: '公司注册地址',
    correspondenceAddress: '联络地址',
    residentialAddress: '住址',
    email: '电子邮件',
    fax: '传真',
    telephoneMobile: '手提电话',
    telephoneHome: '住宅电话',
    telephoneOffice: '办公室电话'
  },
  validation,
  home: homepage,
  auth,
  error,
  fitComponents,
  adm,
  osm,
  crm,
  my: my,
  dw,
  quick
}



// WEBPACK FOOTER //
// ./src/langs/zh_cn/index.js